import request from "@/utils/request";


//新增充值记录
export function addUSDERecharge(data) {
    return request({
        url: '/web/orders/addRecharge',
        method: 'post',
        data: data
    })
}

//查询充值记录
export function getUSDERechargeList(data) {
    return request({
        url: '/web/orders/list',
        method: 'get',
        params: data
    })
}
//查询质押账户列表

export function getImpawnUserList(data) {
    return request({
        url: '/system/impawnUser/list',
        method: 'get',
        params: data
    })
}
// 战车详情
export function getImpawnUserDetail(id) {
    return request({
        url: `/system/impawnUser/${id}`,
        method: 'get',
    })
}
// 查询质押记录
export function getStakingRecord(data) {
    return request({
        url: '/web/record/list',
        method: 'get',
        params: data
    })
}
//验证充值是否成功
export function rechargeIdTrue(data) {
    return request({
        url: '/web/orders/rechargeUSDE',
        method: 'post',
        data: data
    })
}

//新增报销申请
export function getReimburseList(data) {
    return request({
        url: '/system/reimburse/apply/list',
        method: 'get',
        params: data
    })
}

//新增报销申请
export function addReimburseList(data) {
    return request({
        url: '/system/reimburse/apply/add',
        method: 'post',
        data: data
    })
}
// 新增交易日志

export function addOperateList(data) {
    return request({
        url: '/system/operate',
        method: 'post',
        data: data
    })
}
//取消报销申请
export function removeReimburse(data) {
    return request({
        url: '/system/reimburse/apply/' + data,
        method: 'delete',
    })
}

//获取当前用户业绩
export function getYeJi(data) {
    return request({
        url: '/web/user/getTotalPerformanceByDate/' + data.address,
        method: 'get',
        params: {
            nowTime: data.nowTime
        }
    })
}


// 充值过多少usde
export function historyUsde(address) {
    return request({
        url: '/web/rechargeRecord/getChargeUsde/' + address,
        method: 'get'
    })
}




//新增充值额度记录
export function amountAdd(data) {
    return request({
        url: '/system/amount/addRechargeImpawn',
        method: 'post',
        data: data
    })
}

//获取充值额度记录
export function amountList(data) {
    return request({
        url: '/system/amount/list' ,
        method: 'get',
        params:data
    })
}
//核验充值额度
export function amountRechargeImpawnUsde(data) {
    return request({
        url: '/system/amount/rechargeImpawnUsde',
        method: 'post',
        data: data
    })
}


//获取质押收益记录
export function getIncomeRecordList(data) {
    return request({
        url: '/system/incomeRecord/list' ,
        method: 'get',
        params:data
    })
}
// 获取订单详情

export function getByOrderNumber(orderNumber) {
    return request({
        url: `/web/orders/getByOrderNumber/${orderNumber}` ,
        method: 'get',
    })
}
// 修改
export function editUSDERecharge(data) {
    return request({
        url: '/web/orders/edit' ,
        method: 'put',
        data:data
    })
}
// 修改涡轮订单
export function editAmount(data) {
    return request({
        url: '/system/amount/edit' ,
        method: 'put',
        data:data
    })
}
// 删除记录
export function deleteUSDERecharge(id) {
    return request({
        url: `/web/orders/delete/${id}` ,
        method: 'delete',
    })
}
// 删除涡轮记录
export function deleteAmountRecharge(id) {
    return request({
        url: `/system/amount/${id}` ,
        method: 'delete',
    })
}